import { render, staticRenderFns } from "./AppOrdinaryQuestions.vue?vue&type=template&id=057f2631"
import script from "./AppOrdinaryQuestions.vue?vue&type=script&lang=js"
export * from "./AppOrdinaryQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports